<div class="component-container player-stats" *ngIf="broadcast?.customTable"
     [style.width]="broadcast.customTable.width + 'px'"
     [class]="controlAction">
  <div class="stats">
    <div class="name"
         [style.background-color]="getTeamBgr()">
      <div>{{broadcast?.customTable?.title.toUpperCase()}}</div>
    </div>
    <div class="data">
      <ng-container *ngFor="let row of broadcast?.customTable?.data">
        <div *ngIf="row?.value?.length">
          <div>{{row?.label}}</div>
          <div>{{row?.value}}</div>
        </div>
        <div *ngIf="!row?.value?.length && row?.label?.length">
          {{row?.label}}
        </div>
      </ng-container>
    </div>
  </div>
</div>
